/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Configuration for restoring to RDS.
*/
export class AwsDatabaseDestination {
  /**
  * Region to restore to.
  */
  'restoreRegion': string;
  /**
  * ID of the key you want Eon to use for encrypting the restored resource.
  */
  'encryptionKeyId': string;
  /**
  * Name to assign to the restored resource.
  */
  'restoredName': string;
  /**
  * List of security group IDs to associate with the restored resource. Must be in the same VPC of `subnetGroup`. 
  */
  'securityGroups'?: Array<string>;
  /**
  * Subnet group ID to associate with the restored resource. Must be in the same VPC of `securityGroup`. 
  */
  'subnetGroup'?: string;
  /**
  * Instance class to use for the restored resource.
  */
  'dbInstanceClass'?: string;
  /**
  * Tags to apply to the restored instance as key-value pairs, where key and value are both strings.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreRegion",
      "baseName": "restoreRegion",
      "type": "string",
      "format": ""
    },
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoredName",
      "baseName": "restoredName",
      "type": "string",
      "format": ""
    },
    {
      "name": "securityGroups",
      "baseName": "securityGroups",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "subnetGroup",
      "baseName": "subnetGroup",
      "type": "string",
      "format": ""
    },
    {
      "name": "dbInstanceClass",
      "baseName": "dbInstanceClass",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsDatabaseDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

